var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-lg-wrap mb-4" },
    [
      _c("article", { staticClass: "additional-color selected mr-3 my-2" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "item-img-wrapper" }, [
            _c(
              "a",
              { attrs: { href: "/" } },
              [
                _c("lazy-img", {
                  attrs: {
                    "image-url":
                      _vm.currentItem.data.images.all[0].urlPreview ||
                      _vm.currentItem.data.images.all[0].urlMiddle,
                    "picture-class": "img-fluid",
                    "show-percentage": _vm.showPercentageItem,
                    "gray-overlay": true,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.displayedVariations, function (variation, index) {
        return _c(
          "article",
          { key: index, staticClass: "additional-color mr-3 my-2" },
          [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", { staticClass: "item-img-wrapper" }, [
                _c(
                  "a",
                  { attrs: { href: _vm._f("itemURL")(variation.data) } },
                  [
                    _c("lazy-img", {
                      attrs: {
                        "image-url":
                          variation.data.images.all[0].urlPreview ||
                          variation.data.images.all[0].urlMiddle,
                        "picture-class": _vm.getPictureClass(variation),
                        "show-percentage": _vm.showPercentageSign(variation),
                        "gray-overlay": true,
                        "not-available":
                          variation.data.variation.availabilityId > 7,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      this.variations.length > _vm.itemsToShow &&
      !_vm.showAll &&
      !_vm.isMobile &&
      this.variations.length - this.itemsToShow != 1
        ? _c(
            "div",
            {
              staticClass: "additional-color mr-2",
              on: { click: _vm.loadMore },
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "item-img-wrapper mr-2 position-relative more-items",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "h4 position-absolute w-100 font-weight-bolder text-dark mb-0",
                      },
                      [
                        _vm._v(
                          "\n                    + " +
                            _vm._s(this.variations.length - _vm.itemsToShow) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("lazy-img", {
                      attrs: {
                        "image-url":
                          _vm.variations[_vm.itemsToShow].data.images.all[0]
                            .urlPreview ||
                          _vm.variations[_vm.itemsToShow].data.images.all[0]
                            .urlMiddle,
                        "picture-class": "img-fluid grayscale",
                        "gray-overlay": true,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }